<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="个人信息" name="info">
				<change-info v-if="activeName=='info'" @tab="refreshRoute"></change-info>
			</el-tab-pane>
			<el-tab-pane label="修改密码" name="password">
				<change-password v-if="activeName=='password'" @tab="refreshRoute"></change-password>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import ChangeInfo from "@/views/User/subs/ChangeInfo.vue";
import ChangePassword from "@/views/User/subs/ChangePassword.vue";

export default {
	data() {
		return {
			loadings: {
				main: false
			},
			activeName: "info"
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshRoute();
	},
	methods: {
		refreshRoute(tab = null) {
			if (!tab) {
				if (this.$route.params.tab) {
					this.activeName = this.$route.params.tab;
				}
			} else {
				this.activeName = tab;
			}
		}
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: {
			handler(val) {
				if (val) {
					this.refreshRoute();
				}
			},
			immediate: true,
			deep: true
		}
	},
	components: {
		ChangePassword,
		ChangeInfo
	}
};
</script>
<style lang="scss" scoped>
</style>
